import * as React from 'react';
import Svg, {Path, SvgProps} from 'react-native-svg';
const SvgComponent = (props: SvgProps) => (
  <Svg
    width={31}
    height={31}
    viewBox="0 0 31 31"
    {...props}
    fill="none"
    stroke="none">
    <Path
      fill={props.fill || '#070A7A'}
      d="M15.28.52c-8.27 0-15 6.73-15 15s6.73 15 15 15 15-6.73 15-15-6.73-15-15-15Zm0 2c7.19 0 13 5.81 13 13 0 3.61-1.46 6.87-3.82 9.22-1.65-4.7-5.13-7.89-9.18-7.89s-7.53 3.19-9.18 7.89a12.964 12.964 0 0 1-3.82-9.22c0-7.19 5.81-13 13-13Zm0 3c-2.75 0-5 2.25-5 5s2.25 5 5 5 5-2.25 5-5-2.25-5-5-5Zm0 2c1.67 0 3 1.33 3 3s-1.33 3-3 3-3-1.33-3-3 1.33-3 3-3Zm0 11.33c3.16 0 6.18 2.73 7.52 7.28a12.898 12.898 0 0 1-7.52 2.39c-2.81 0-5.4-.88-7.52-2.39 1.34-4.56 4.36-7.28 7.52-7.28Z"
    />
  </Svg>
);
export default SvgComponent;
